<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.crop_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <div class="form-group has-label">
              <label>{{ $t('common_words.crop') }}: *</label>
              <br />
              <el-select
                clearable
                filterable
                class="select-primary custom-width-select required-third-step shadow-sm"
                size="large"
                v-model="model.crop_id"
                :placeholder="`${$t('common_words.select')}...`"
                @change="emitVarieties"
              >
                <el-option
                  v-for="option in crops"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="`${option.id}-${option.name}`"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group has-label">
              <label>{{ $t('common_words.type_of_crop') }}: *</label>
              <br />
              <el-select
                clearable
                filterable
                class="select-primary custom-width-select required-third-step shadow-sm"
                size="large"
                v-model="model.crop_type_id"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="option in croptypes"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.name"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label></label>
              <p>{{ $t('common_words.production_device') }}</p>
              <el-select
                @change="selectAllFromSelect('model.devices', device_types)"
                clearable
                multiple
                class="select-primary shadow-sm"
                size="large"
                v-model="model.devices"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="option in device_types"
                  class="select-primary selected-all"
                  :value="option.id"
                  :label="option.name"
                  :key="option.name"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <fg-input
              type="number"
              :label="`${$t('production.weight_tara_percentage')}: `"
              v-model="model.tara_weight"
              name="production.weight_tara"
              v-validate="modelValidations.tara_weight"
              :error="getError('production.weight_tara', true)"
              min="0"
            ></fg-input>
          </div>
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <label>{{ $t('production.box_unit_weight') }}: </label>
            <br />
            <el-select
              class="select-primary shadow-sm w-100"
              size="large"
              v-model="model.unit_box_weight"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                value="kg"
                :label="$t('common_words.kg')"
              ></el-option>
              <el-option
                class="select-primary"
                value="lb"
                :label="$t('common_words.pounds')"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <label>{{ $t('production.fruit_weight_unit') }}: </label>
            <br />
            <el-select
              class="select-primary shadow-sm w-100"
              size="large"
              v-model="model.unit_tara_weight"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                value="kg"
                :label="$t('common_words.kg')"
              ></el-option>
              <el-option
                class="select-primary"
                value="lb"
                :label="$t('common_words.pounds')"
              ></el-option>
            </el-select>
          </div>

          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <label>{{ $t('labor.length_unit') }}: </label>
            <br />
            <el-select
              class="select-primary shadow-sm w-100"
              size="large"
              v-model="model.length_unit"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                value="cm"
                :label="$t('common_words.centimeters')"
              ></el-option>
              <el-option
                class="select-primary"
                value="in"
                :label="$t('common_words.inches')"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  data() {
    return {
      model: {
        crop_id: null,
        crop_type_id: null,
        devices: null,
        tara_weight: 0,
        unit_tara_weight: 'kg',
        unit_box_weight: 'kg',
        length_unit: 'cm',
      },
      modelValidations: {
        tara_weight: {
          min: 0,
          max: 100,
        },
      },
      crops: null,
      croptypes: null,
      device_types: null,
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinLoading,
    MixinAlert,
    MixinValidations,
  ],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.device_types = this.concatAll(this.device_types.splice(1));
    },

    emitVarieties(id) {
      Axios.getMasters('cropvarieties/' + id)
        .then((response) => {
          this.$emit('emit-methods', 'setVarieties', response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          if (!res) return res;

          if (!isset(this.model.crop_id) || !isset(this.model.crop_type_id)) {
            this.validationInputsRequired('third-step', false, true);
            return false;
          } else return res;
        })
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            nameCrop: this.crops
              .filter((crop) => this.model.crop_id == crop.id)
              .map((crop) => crop.name),
            nameCropType: this.croptypes
              .filter((type) => this.model.crop_type_id == type.id)
              .map((type) => type.name),
            nameDevices: this.device_types
              .filter((device) => this.model.devices.includes(device.id))
              .map((device) => device.name),
          });

          return res;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('farms/crops')
        .then((response) => {
          this.crops = response.data.data;
          if (!sessionStorage.getItem('editForm') && this.crops.length == 1) {
            this.model.crop_id = this.crops[0].id;
          }

          Axios.getMasters('croptypes')
            .then((response1) => {
              this.croptypes = response1.data.data;
              if (
                !sessionStorage.getItem('editForm') &&
                this.croptypes.length == 1
              ) {
                this.model.crop_type_id = this.croptypes[0].id;
              }

              Axios.getMasters('devices/equipments/only')
                .then((response2) => {
                  this.device_types = this.concatAll(response2.data.data);

                  if (
                    !sessionStorage.getItem('editForm') &&
                    this.device_types.length == 1
                  ) {
                    this.model.devices.push(this.device_types[0].id);
                  }
                })
                .catch((error) => this.showMessageErrors(error));
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const {
        crop_id,
        crop_type_id,
        tara_weight,
        unit_tara_weight,
        unit_box_weight,
        length_unit,
        devices,
      } = JSON.parse(sessionStorage.getItem('editForm'));

      this.model = {
        crop_id,
        crop_type_id,
        tara_weight,
        unit_tara_weight,
        unit_box_weight,
        length_unit,
        devices: devices.map((device) => device.id),
      };
    }
  },
};
</script>
<style></style>
